import { lineString } from '@turf/helpers';
import { defaultBounds } from '../defaultBBox';

export const turfLineString: typeof lineString = (value, properties, options) => {
  const coords = value && value.length > 2 ? value : defaultBounds;
  return lineString(coords, properties, options);
};
